import { params } from "./wsDataManager";

/**
 * 改造下：保存二进制数据，在需要渲染时，才转换为json数据；
 */

let data_list = []//原始数据保存的list
/**
 * 
 * @param {*} data 
 */
export function saveCacheData(data) {
  data_list.push(data)
};

/**
 * 根据播放时间点、步长获取合适的数据
 * @param {*} time 时间点
 * @param {*} step 步长 毫秒；
 */
export function getCacheData(time, step) {
  let min = time - step / 2;
  let max = time + step / 2;
  let data = data_list.find(item => item.timestamp >= min && item.timestamp < max)
  return data;
}
/**
 * 根据播放时间点、步长获取合适的数据  地图数据
 * @param {*} time 时间点
 * @param {*} step 步长 毫秒；
 */
export function getCacheData_Map(time, step) {
  let min = time - step / 2;
  let max = time + step / 2;
  let data = data_list.find(item => item.timestamp >= min && item.timestamp < max&&item.mapData)
  return data;
}

export function clearCacheData() {
  console.log('clear');
  data_list = [];
};

/**
 * 扫描缓存帧中 overwriteMode 变为非 0 的时刻（接管动作），用于进度条 instruction 旗
 * @param {number} startTs 区间起点（ms）
 * @param {number} endTs 区间终点（ms）
 * @returns {Array<{ timestamp: number, mode: number }>}
 */
export function scanOverwriteInstructionTransitions(startTs, endTs) {
  if (!startTs || !endTs || startTs > endTs) return [];
  const result = [];
  let prevMode;
  const frames = data_list
    .filter((item) => item.timestamp >= startTs && item.timestamp <= endTs)
    .sort((a, b) => a.timestamp - b.timestamp);
  for (const frame of frames) {
    const mode = frame?.vehicleData?.overwriteMode;
    if (typeof mode !== 'number') continue;
    if (prevMode === undefined) {
      prevMode = mode;
      continue;
    }
    if (mode !== prevMode && mode !== 0) {
      result.push({ timestamp: frame.timestamp, mode });
    }
    prevMode = mode;
  }
  return result;
}

export function saveChartData(data){
  let chart_list = {
    timestamp:0,
    metricDataFrameList:[]
  };
  if(data?.vehicleData?.metricDataFrameList.length&&data.timestamp){
    chart_list.timestamp = data.timestamp;
    chart_list.metricDataFrameList = data?.vehicleData?.metricDataFrameList;
    return chart_list;
  }
}

